export const HandWithCoins20Icon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path
          d="M3.001 17.457L2.77833 17.29H2.5H0.835V12.085H3.44769L6.96545 15.0165L7.19769 15.21H7.5H11.25H11.4717L11.6643 15.1L16.6878 12.2294C17.7916 11.5987 19.165 12.3957 19.165 13.667C19.165 14.2206 18.8883 14.7376 18.4277 15.0447L12.2472 19.165H5.27833L3.001 17.457Z"
          strokeWidth="1.67"
        />
        <path
          d="M3.72266 12.0793H7.04611C8.04067 12.0793 8.9945 12.4744 9.69776 13.1777L11.4943 14.9742"
          strokeWidth="1.67"
        />
        <ellipse
          cx="6.66683"
          cy="4.16671"
          rx="3.33333"
          ry="3.33333"
          strokeWidth="1.67"
        />
        <ellipse
          cx="12.4998"
          cy="7.49996"
          rx="3.33333"
          ry="3.33333"
          strokeWidth="1.67"
        />
      </g>
    </svg>
  );
};
